import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import OtherDetailsItem from './OtherDetailsItem';
import { sortBy } from 'lodash';

const HorizontalDetails = ({
  itemValue,
  inputSettings,
  jid,
  base_url,
  userToken,
  uuid,
  ixTL,
  handleUpdateOtherDetailsCallBack
}) => {
  const [details, setDetails] = useState(null);
  const [settings, setSettings] = useState(null);
  const handleSetEditMode = key => {
    const copySettings = { ...settings };
    copySettings[key].isEditMode = !copySettings[key].isEditMode;
    setSettings(copySettings);
  };

  const handleSetDetailsChange = ({ key, value }) => {
    const copyDetails = { ...details };
    copyDetails[key] = value;

    setDetails(copyDetails);
    handleUpdateOtherDetailsCallBack({ key, value });
  };

  useEffect(() => {
    let newObjectSettings = {};
    let itemValueInObj = {};

    //settings
    Object.entries(inputSettings || {}).forEach(([key, value]) => {
      newObjectSettings = {
        ...newObjectSettings,
        [key]: {
          ...value,
          isEditMode: false
        }
      };
    });

    //itemValues
    (itemValue || []).forEach(data => {
      itemValueInObj = {
        ...itemValueInObj,
        [data.key]: data.value
      };
    });

    setSettings(newObjectSettings);
    setDetails(itemValueInObj);
  }, [inputSettings, itemValue]);

  return (
    <Paper
      component={Box}
      mb={2}
      p={3}
      borderLeft={3}
      borderColor="primary.main"
    >
      <Grid container spacing={2}>
        {settings &&
          sortBy(Object.entries(settings), [d => d?.[1]?.sort || 0]).map(
            ([key, value]) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={
                  typeof value?.width === 'object'
                    ? Number(value?.width?.md ?? 3)
                    : typeof value?.width === 'number'
                    ? Number(value?.width)
                    : typeof value?.HorizontalWidth === 'object'
                    ? Number(value?.HorizontalWidth?.md ?? 3)
                    : Number(value?.HorizontalWidth ?? 3)
                }
                lg={
                  typeof value?.width === 'object'
                    ? Number(value?.width?.lg ?? 2)
                    : typeof value?.width === 'number'
                    ? Number(value?.width)
                    : typeof value?.HorizontalWidth === 'object'
                    ? Number(value?.HorizontalWidth?.lg ?? 2)
                    : Number(value?.HorizontalWidth ?? 2)
                }
                key={key}
              >
                <OtherDetailsItem
                  jid={jid}
                  value={details}
                  uuid={uuid}
                  ixTL={ixTL}
                  keyItem={key}
                  settings={value}
                  base_url={base_url}
                  userToken={userToken}
                  handleSetEditMode={handleSetEditMode}
                  handleSetDetailsChange={handleSetDetailsChange}
                />
              </Grid>
            )
          )}
      </Grid>
    </Paper>
  );
};
export default HorizontalDetails;
